(function () {
  const ROOT_SELECTOR = '.back-to-school-section2';
  const READY_ATTR = 'data-bts26-wenhao-ready';

  function closeAll(root) {
    root.querySelectorAll('.common-icon-tanchuang-box.icon-hover').forEach(function (box) {
      box.classList.remove('icon-hover');
    });
    root.querySelectorAll('.wenhao.wenhao-hover').forEach(function (el) {
      el.classList.remove('wenhao-hover');
    });
  }

  function bindItem(item, root) {
    var parent = item.closest('.common-icon-item-sy');
    var popup = parent && parent.querySelector('.common-icon-tanchuang-box');
    if (!popup) return;
    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    var show = function () {
      closeAll(root);
      popup.classList.add('icon-hover');
      item.classList.add('wenhao-hover');
    };

    var hide = function () {
      popup.classList.remove('icon-hover');
      item.classList.remove('wenhao-hover');
    };

    if (finePointer) {
      item.addEventListener('mouseenter', show);
      item.addEventListener('mouseleave', function (event) {
        if (popup.contains(event.relatedTarget)) return;
        hide();
      });
      popup.addEventListener('mouseenter', show);
      popup.addEventListener('mouseleave', hide);
    }
    item.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      var isOpen = popup.classList.contains('icon-hover');
      closeAll(root);
      if (!isOpen) show();
    });
  }

  function initRoot(root) {
    if (!root || root.getAttribute(READY_ATTR) === 'true') return;
    root.setAttribute(READY_ATTR, 'true');
    root.querySelectorAll('.wenhao').forEach(function (item) {
      bindItem(item, root);
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('.wenhao') || event.target.closest('.common-icon-tanchuang-box')) return;
    document.querySelectorAll(ROOT_SELECTOR).forEach(closeAll);
  });

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector
      ? event.target.querySelector(ROOT_SELECTOR)
      : null;
    if (!root && event.target.closest) {
      root = event.target.closest(ROOT_SELECTOR);
    }
    if (!root) return;
    root.removeAttribute(READY_ATTR);
    initRoot(root);
  });
})();

(function () {
  const ROOT_SELECTOR = '.back-to-school-feature-product';
  const POPUP_SELECTOR = '.common-pop-up-itemcontainer';
  const BUNDLE_SELECTOR = '.card-product-3__bundle';
  const QTY_SELECTOR = '.quantity_input, [data-quantity-variant-id]';
  const READY_ATTR = 'data-bts26-bundle-selected-ready';

  function getQuantity(bundle) {
    var input = bundle.querySelector(QTY_SELECTOR);
    if (!input) return 0;
    var value = parseInt(input.value, 10);
    return Number.isNaN(value) ? 0 : value;
  }

  function syncPopupBundleSelected(popup) {
    if (!popup) return;
    popup.querySelectorAll(BUNDLE_SELECTOR).forEach(function (bundle) {
      bundle.classList.toggle('selected', getQuantity(bundle) > 0);
    });
  }

  function syncPopupsInRoot(root) {
    if (!root) return;
    root.querySelectorAll(POPUP_SELECTOR).forEach(syncPopupBundleSelected);
  }

  function onPopupInteraction(event) {
    var root = event.target.closest(ROOT_SELECTOR);
    if (!root) return;

    if (event.target.closest('.dialog-show-btn')) {
      window.requestAnimationFrame(function () {
        syncPopupsInRoot(root);
      });
      return;
    }

    var popup = event.target.closest(POPUP_SELECTOR);
    if (!popup) return;
    syncPopupBundleSelected(popup);
  }

  function init() {
    if (document.documentElement.getAttribute(READY_ATTR) === 'true') return;
    document.documentElement.setAttribute(READY_ATTR, 'true');
    document.addEventListener('click', onPopupInteraction);
    document.addEventListener('change', onPopupInteraction);
    document.addEventListener('input', onPopupInteraction);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
